'use client';

import KeyIconsSection from './key-icons-section';
import KeyMainSection from './key-main-section';
import KeyTitle from './key-title';

type ProductListKeyProps = {
  isProductVariant?: boolean;
};

const ProductListKey = ({ isProductVariant = false }: ProductListKeyProps) => {
  return (
    <>
      <KeyTitle />
      <div className="d-md-flex mt-2 pt-3 gap-4">
        <KeyMainSection isProductVariant={isProductVariant} />
        <KeyIconsSection />
      </div>
    </>
  );
};

export default ProductListKey;
